var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmBell2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13071_170084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 0.714294C11.6255 0.714294 13.1843 1.35998 14.3336 2.50931C15.483 3.65864 16.1286 5.21747 16.1286 6.84287C16.1286 13.6572 18.6144 15 19.2858 15H0.714355C1.40007 15 3.8715 13.6429 3.8715 6.84287C3.8715 5.21747 4.51719 3.65864 5.66652 2.50931C6.81585 1.35998 8.37467 0.714294 10.0001 0.714294V0.714294Z",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85693 17.6143C7.98042 18.0886 8.25779 18.5086 8.64558 18.8084C9.03337 19.1081 9.50965 19.2707 9.99979 19.2707C10.4899 19.2707 10.9662 19.1081 11.354 18.8084C11.7418 18.5086 12.0192 18.0886 12.1426 17.6143",
    stroke: "#007293",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13071_170084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmBell2);
export default __webpack_public_path__ + "static/media/alarm-bell-2.5d65479a59773ae2a0b3809d1a749b97.svg";
export { ForwardRef as ReactComponent };